import React, { Component, useContext, useEffect, useState } from "react";
import "./SpsCommerceReceiveOrdersModal.scss";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import ISpsCommerceFilterTransactionsDTO from "../../../../models/DTO/ISpsCommerceFilterTransactionsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ISpsCommerceOnFilterTransactionsDTO from "../../../../models/DTO/ISpsCommerceOnFilterTransactionsDTO";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const SpsCommerceReceiveOrdersModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        props.socket.emit(EndpointsEnum.SpsCommerceOnFilterTransactions, onGetTransactions);
        props.socket.emit(EndpointsEnum.Notify, onNotify);

        return () => {
            props.socket.emit(EndpointsEnum.Notify, onNotify);
        };
    });

    const onNotify = () => {
        setIsActive(false);
    };

    const closeModal = () => {
        props.closeModalFn();
    };

    const startGetTransactions = () => {
        const payload: ISpsCommerceFilterTransactionsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            directoryPath: "/out",
        };

        props.socket.emit(EndpointsEnum.SpsCommerceFilterTransactions, payload);

        setIsActive(true);
    };

    const onGetTransactions = (data: ISpsCommerceOnFilterTransactionsDTO) => {
        console.log(data);
    };

    return (
        <div className={"SpsCommerceReceiveOrdersModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-download"} title={"sps_commerce_receive_orders"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwButton title={"start"} fn={startGetTransactions} active={isActive} disableOnActive={true} />
                </div>
            </div>
        </div>
    );
};
